<form [formGroup]="fgFilters">
  <app-main-filters
    [fgFilters]="fgFilters"
    [filters]="filters"
    [isLoadingFilters]="isLoadingFilters"
    (changeMainFilters)="changeMainFilters($event)"
    (outsideDiameterChanged)="onOutsideDiameterChanged($event)"
    (wallThicknessChanged)="onWallThicknessChanged($event)"
  ></app-main-filters>
  <app-sub-filters
    [fgFilters]="fgFilters"
    [filters]="filters"
    (changeSubFilters)="changeSubFilters($event)"
    *ngIf="subfiltersVisible"
  ></app-sub-filters>
</form>
